<script setup lang="ts">
const { pages } = useSwiftSearchHelper()
const route = useRoute()
const currentPage = computed(() =>
  route.params.page ? parseInt(route.params.page as string) : 1
)
const queries = computed(() => route.query)

const { overflowAuto } = useBodyOverflowManager()

const { maxPages } = defineProps<{ maxPages?: number }>()

watchDebounced(
  queries,
  () => {
    if (import.meta.server) return
    // Close mobile filter panel when query changes (IS v5 handles page reset internally)
    useTimeoutFn(() => {
      overflowAuto()
    }, 1000)
  },
  {
    debounce: 500,
    deep: true
  }
)
</script>
<template>
  <NavigationPaginator
    v-if="pages > 1"
    class="mx-auto mt-2"
    :current-page="currentPage"
    :total-pages="maxPages ? Math.min(pages, maxPages) : pages"
  />
</template>
